import { useEffect, useMemo, useState } from "react";

/**
 * Tracks "now" on a 30s tick and returns the (possibly fractional) row index
 * BETWEEN the two block rows that bracket the current time. Returns -1 when
 * "now" is outside the rendered window.
 */
export function useNowLine(rows) {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 30000);
    return () => clearInterval(id);
  }, []);

  const nowRowIndex = useMemo(() => {
    let prev = -1;
    for (let i = 0; i < rows.length; i++) {
      const r = rows[i];
      if (r.kind === "block") {
        const t = new Date(r.block.start_at).getTime();
        if (t > now.getTime()) return prev + 0.5;
        prev = i;
      }
    }
    return -1;
  }, [rows, now]);

  return nowRowIndex;
}
